import { render, staticRenderFns } from "./DefaultFormNotification.vue?vue&type=template&id=11a758d0&scoped=true&"
import script from "./DefaultFormNotification.vue?vue&type=script&lang=js&"
export * from "./DefaultFormNotification.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFormNotification.vue?vue&type=style&index=0&id=11a758d0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a758d0",
  null
  
)

export default component.exports